import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, makeStyles, Paper } from "@material-ui/core";
import SectionTitle from "features/common/components/SectionTitle";
import assetPageStyle from "features/assets/styles";
import { get, set } from "@totalsoft/react-state-lens";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import { emptyString } from "constants/defaultValues";
import { getErrors, isValid } from "@totalsoft/pure-validations-react";

const useStyles = makeStyles(assetPageStyle);

function EstimationHeaderCard(props) {
  const { quoteLens, disabled, validation } = props;

  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <SectionTitle title={t("Asset.Estimation")} />
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.filterStyle}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomTextField
                fullWidth
                label={t("Asset.EstimationName")}
                value={(quoteLens.estimationName |> get) || emptyString}
                disabled={disabled}
                required
                onChange={quoteLens.estimationName |> set |> onTextBoxChange}
                error={!isValid(validation.estimationName)}
                helperText={getErrors(validation.estimationName)}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}

EstimationHeaderCard.propTypes = {
  quoteLens: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  validation: PropTypes.object.isRequired,
};

export default EstimationHeaderCard;
